import { useCallback } from 'react';
import { useAuth } from '../../context/Auth';
export function useSignout() {
    const { authService } = useAuth();
    const signout = useCallback(() => {
        if (window && window.sessionStorage) {
            sessionStorage.clear();
        }
        // Move into a function when Heap has been moved to Shared.
        if (window && window.heap) {
            try {
                window.heap.resetIdentity();
                window.heap.clearEventProperties();
            }
            catch {
                //we dont want to prevent the logout from happening if there is a heap error so just swallow.
            }
        }
        authService.logout();
    }, [authService]);
    return { signout };
}
